import { index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

import { applications } from './applications';
import { candidates } from './candidates';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const sentMessages = pgTable(
  'sent_messages',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    applicationId: uuid('application_id')
      .notNull()
      .references(() => applications.id),
    candidateId: uuid('candidate_id')
      .notNull()
      .references(() => candidates.id),
    channel: text('channel', { enum: ['email', 'sms'] }).notNull(),
    type: text('type', { enum: ['invite', 'reminder'] }).notNull(),
    language: text('language').notNull(),
    recipient: text('recipient').notNull(),
    subject: text('subject'),
    body: text('body').notNull(),
    externalId: text('external_id'),
    status: text('status', {
      enum: ['queued', 'sent', 'delivered', 'failed', 'bounced']
    }).notNull(),
    errorMessage: text('error_message'),
    sentAt: timestamp('sent_at', { withTimezone: true }),
    createdAt: timestamp('created_at', { withTimezone: true }).notNull().defaultNow()
  },
  (t) => [
    index('sent_messages_app_channel_type_idx').on(t.applicationId, t.channel, t.type),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();
